export default __webpack_public_path__ + "static/media/ninjapod-logo.98a93a64.png";